/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { P as Panel, d as defineCustomElement$1 } from './panel.js';

const CalcitePanel = Panel;
const defineCustomElement = defineCustomElement$1;

export { CalcitePanel, defineCustomElement };

//# sourceMappingURL=calcite-panel.js.map